import React, { Component } from "react";
import "./Loading.css";
import loadingGif from "../../resources/Double Ring-1s-200px.gif";

export default class Loading extends Component {
  render() {
    return (
      <section id="page-splash">
        <h3 className="fp-logo">CMS - Translator Tool</h3>
        <div className="fp-signed-out-only">
          <img
            src={loadingGif}
            alt="loading"
            style={{ size: "200px 200px" }}
          />
        </div>
      </section>
    );
  }
}
